const navbar = document.getElementsByClassName('navbar').item(0);
const header = document.getElementsByClassName('navbar-header').item(0);
const brand = document.getElementsByClassName('navbar-brand').item(0);
const right = document.getElementsByClassName('navbar-right').item(0);

const megamenuButton = document.createElement('button');
megamenuButton.type = "button";
megamenuButton.className = "navbar-toggler megamenu-toggler hidden-lg";
megamenuButton.innerHTML = '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"></path></svg>';

if (header.clientWidth === navbar.clientWidth) {
  header.prepend(megamenuButton);
} else {
  right.append(megamenuButton);
}

window.addEventListener('resize', function () {
  if (header.clientWidth === navbar.clientWidth) {
    header.prepend(megamenuButton);
  } else {
    right.append(megamenuButton);
  }
});

const megamenu = document.createElement('div');
megamenu.id = 'megamenu';
megamenu.className = 'megamenu collapse';
document.body.append(megamenu);

megamenuButton.addEventListener('click', function () {
  $(megamenu).collapse('toggle');
});

const navbarToggleButton = document.getElementsByClassName('navbar-toggle').item(0);
navbarToggleButton.className = 'navbar-toggler';
navbarToggleButton.innerHTML = '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"></path></svg>';

brand.firstElementChild.src = 'https://static.opensuse.org/favicon.svg';
brand.lastChild.textContent = brand.lastChild.textContent.replace('openSUSE', '');
